<template>
  <div class="page-content bg-img resources">
    <div class="page-header">
      <h2>RESOURCES</h2>
    </div>
    <div class="text-container">
      <img
        src="@/assets/images/intro-bg.jpg"
        class="intro-bg"
        alt="image description"
      />
      <div class="text-content text-content-direction">
        <p>For additional information, visit:</p>
        <p>
          It’s time to show what you know about not sweating it! Here’s how it
          works:
        </p>
        <ol class="numbered-list">
          <li v-for="item in items" :key="item" v-html="item"></li>
        </ol>
      </div>
      <div class="btn-holder">
        <a href="#" class="btn-next" @click.prevent="goToNextStep">
          <span>Play again</span>
        </a>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "Resources",
  computed: {
      ...mapGetters({
        items: 'getResourcesItems'
      })
    },
    methods: {
      ...mapMutations({
        next: 'nextStep',
        stop: 'stop'
      }),
      goToNextStep() {
        this.next();
        // this.stop('theme_music');
      }
    },
  mounted() {
    window.dispatchEvent(new Event("resize"));
  },
};
</script>
  